import { defineMessages } from "react-intl"

export default defineMessages({
  btn_spradling_home: {
    id: "Claims.Thankyou.BtnSpradlingHome",
    defaultMessage: "Spradling Home"
  }
})
